<div
  class="schedule-item flex-start-center gap-4 min-width-0 overflow-hidden"
  [ngStyle]="{'background-color': backgroundColor, 'border-color': borderColor, 'box-shadow': boxShadow}"
  [matTooltip]="scheduleItem.name + ' ' + (startDateTime | DateTime: 'TIME_SIMPLE') + ' - ' + (endDateTime | DateTime: 'TIME_SIMPLE')"
>
  @if (isSelected) {
    <mat-checkbox color="primary" [checked]="scheduleItem.selected" (change)="valueChanged($event)"></mat-checkbox>
  }
  <div class="bar">
    <span class="title">{{ scheduleItem.name }}</span>
    <span class="time">{{ startDateTime | DateTime: 'TIME_SIMPLE' }} - {{ endDateTime | DateTime: 'TIME_SIMPLE' }}</span>
  </div>
  <mat-icon
    svgIcon="solid-delete"
    class="icon-12 delete"
    [matTooltip]="'ANGULAR_COMPONENT_LIBRARY.GENERAL.ACTIONS.DELETE' | bmsTranslate"
    [matTooltipPosition]="'above'"
    (click)="deleteEvent.emit()"
  ></mat-icon>
</div>
<div class="breaks-container full-height overflow-hidden">
  @for (break of breaks; track $index) {
    <div class="break full-height" [style.margin-left.px]="break.left" [style.width.px]="break.width"></div>
  }
</div>
